module.exports = __webpack_public_path__ + "static/dashboard-28819a9eb0234dfadcf6a02e63c1d4be.mp4";